import { jsx as _jsx } from "react/jsx-runtime";
import { getDeleteTimetableSlotsMutationOptions, isLoading, useDeleteTimetableSlotsMutation, } from 'api';
import { DeletionConfirmationDialog, LoadingWrapper } from 'components/custom';
import { enqueueSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
const DeleteCourseSlotsDialog = (props) => {
    const { courseToClearSlots, setCourseToClearSlots, timetableId } = props;
    const { t } = useTranslation('timetable', {
        keyPrefix: 'steps.lessons.cmp.DeleteCourseSlotsDialog',
    });
    const [deleteSlot, statusDeleteSlot] = useDeleteTimetableSlotsMutation();
    const handleDelete = () => {
        if (courseToClearSlots?.id) {
            void deleteSlot(getDeleteTimetableSlotsMutationOptions({
                courseId: courseToClearSlots.id,
                timetableId,
            })).then(() => {
                setCourseToClearSlots(undefined);
                enqueueSnackbar(t('successMessage'));
            });
        }
    };
    return (_jsx(DeletionConfirmationDialog, { open: !!courseToClearSlots?.id, onClose: () => {
            setCourseToClearSlots(undefined);
        }, titleProps: {
            text: t('title'),
        }, cancelButtonProps: {
            onClick: () => {
                setCourseToClearSlots(undefined);
            },
        }, confirmButtonProps: {
            children: t('actions.delete'),
            disabled: isLoading(statusDeleteSlot),
            onClick: handleDelete,
        }, children: _jsx(LoadingWrapper, { mutation: statusDeleteSlot, children: t('text', {
                name: courseToClearSlots?.name,
            }) }) }));
};
export default DeleteCourseSlotsDialog;
